
interface Props {
  label: string;
  value: string | number;
  delta: string;
  deltaUp: boolean;
  color: string;
  icon: string;
}

export default function StatCard({ label, value, delta, deltaUp, color, icon }: Props) {
  return (
    <div className="panel" style={{ padding: 18, position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: color }} />

      <div style={{
        width: 36, height: 36, borderRadius: 9,
        background: color + '22',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 16, marginBottom: 12, color,
      }}>{icon}</div>

      <div style={{
        fontFamily: 'Barlow Condensed, sans-serif',
        fontWeight: 800, fontSize: 32,
        color: 'var(--text)', letterSpacing: -1, lineHeight: 1,
      }}>{value}</div>

      <div className="label-caps" style={{ marginTop: 4 }}>{label}</div>

      <div style={{
        display: 'inline-flex', alignItems: 'center', gap: 3,
        marginTop: 8, padding: '3px 7px', borderRadius: 20,
        background: deltaUp ? 'rgba(15,168,109,0.12)' : 'rgba(191,30,46,0.1)',
        color: deltaUp ? '#0fa86d' : '#bf1e2e',
        fontSize: 11, fontWeight: 600,
      }}>
        {deltaUp ? '↑' : '↓'} {delta}
      </div>
    </div>
  );
}